export function normalize(string) {
	return string.trim().toLowerCase();
}